"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
/**
 * Provides loading progress bar start, stop functionality and loading information.
 */
var LoadingBarService = /** @class */ (function () {
    function LoadingBarService() {
        this.isLoading = false;
        this.loadingSubject = new ReplaySubject_1.ReplaySubject(1);
        this.timeoutId = undefined;
    }
    LoadingBarService.prototype.start = function () {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        if (!this.isLoading) {
            this.isLoading = true;
            this.loadingSubject.next(this.isLoading);
        }
    };
    LoadingBarService.prototype.stop = function () {
        var _this = this;
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout(function () {
            _this.isLoading = false;
            _this.loadingSubject.next(_this.isLoading);
        }, 800);
    };
    /**
     * Provides status if there is loading or no
     * @returns {Observable<T>}
     */
    LoadingBarService.prototype.loading = function () {
        return this.loadingSubject.asObservable();
    };
    LoadingBarService = __decorate([
        core_1.Injectable()
    ], LoadingBarService);
    return LoadingBarService;
}());
exports.LoadingBarService = LoadingBarService;
//# sourceMappingURL=loading-bar.service.js.map